/** Expired authentication preserves the gift reference so sign-in can resume linking. */
export function isPermanentGiftLinkFailure(status: number | undefined): boolean {
  return status !== undefined && status >= 400 && status < 500 && status !== 401 && status !== 429;
}

const normalizeEmail = (value: string | null | undefined) => value?.trim().toLowerCase() ?? "";

/**
 * A retained anonymous claim is eligible for the first authenticated donor.
 * Once the checkout captured an email, only that donor may consume the claim;
 * another user leaves it dormant for the original donor's next sign-in.
 */
export function canHandleGiftLinkForAuthenticatedEmail(
  claimEmail: string | null | undefined,
  authenticatedEmail: string | null | undefined,
): boolean {
  const expected = normalizeEmail(claimEmail);
  if (!expected) return true;
  return expected === normalizeEmail(authenticatedEmail);
}
